import styles from "./Error404.module.css";
import Navbar from "../../components/NavBar/Navbar";
import Footer from "../../components/Footer/Footer";
function Error404() {
  return (
    <div>
      <Navbar />
      <div className={styles.error}>
        <h1 className={styles.h1}>ERROR 404! Page Not found</h1>
        <a className={styles.intouch} href="/">
          Go home
        </a>
      </div>
      <Footer />
    </div>
  );
}

export default Error404;
